import { createSlice } from '@reduxjs/toolkit'
import PatientsService from 'services/PatientsService'
import { isEmptyObj } from 'utils/HelperFunctions'

const selectedPatientSlice = createSlice({
  name: 'selectedPatient',
  initialState: {},
  reducers: {
    setSelectedPatient(state, action) {
      return action.payload
    },
    resetSelectedPatientState(state, action) {
      return {}
    }
  },
})

export const { setSelectedPatient, resetSelectedPatientState } =
  selectedPatientSlice.actions

export const selectPatient = (selectedPatientObj) => {
  return async (dispatch, getState) => {
    const state = getState().patient
    if (isEmptyObj(selectedPatientObj)) {
      dispatch(setSelectedPatient(selectedPatientObj))
    }
    else if (state.id !== selectedPatientObj.id) {
      const getFirstObservationData = await PatientsService.getFirstObservation("WEIGHT", selectedPatientObj.id)
      dispatch(setSelectedPatient({ ...selectedPatientObj, firstObservations: getFirstObservationData.data }))
    }
  }
}

export default selectedPatientSlice.reducer